function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useSelector } from 'react-redux';
import map from 'lodash/map';
import get from 'lodash/get';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import { FormattedMessage } from 'react-intl';
import App from 'modules/App';
import Asset from 'components/Asset';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from './DataAccessConsents.pcss';
const ConsentBox = ({ consent })=>{
    const { name, displayName, description, iconUri } = consent;
    const localizationResources = useSelector(App.selectors.localizationResources);
    const displayNameValue = get(localizationResources, [
        displayName,
        'value'
    ], displayName);
    const descriptionValue = get(localizationResources, [
        description,
        'value'
    ], description);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.consents__consent,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.consents__consent__info,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.consents__consent__icon,
                        children: iconUri && /*#__PURE__*/ _jsx(Asset, {
                            src: iconUri
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.consents__consent__description,
                        children: [
                            ...descriptionValue
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.consents__consent__details,
                children: [
                    ...displayNameValue
                ]
            })
        ]
    }, name);
};
const ConsentsList = ({ requestedScopes })=>{
    const { scopeConsents: availableScopes } = useSelector(selectors.client);
    // eslint-disable-next-line @typescript-eslint/typedef
    const scopes = filter(availableScopes, (scope)=>includes(requestedScopes, scope.name));
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: map(scopes, (consent)=>/*#__PURE__*/ _jsx(ConsentBox, {
                consent: consent
            }, consent.name))
    });
};
const DataAccessConsents = ({ requestedScopes })=>{
    const { appName } = useSelector(selectors.client);
    const header = {
        message: messages.headers.itWillAllowAppTo,
        values: {
            appName
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.consents,
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: styles.consents__header,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, header.message), {
                    values: header.values
                }))
            }),
            /*#__PURE__*/ _jsx(ConsentsList, {
                requestedScopes: requestedScopes
            })
        ]
    });
};
export default withStyles(styles)(DataAccessConsents);
